/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class DriverTraining{
    driverId:number;
    attachment:string;
    completeDate:string;
    driverTrainingId:number;
    expirationDate:string;
    siteId:number;
    // course:{
    courseName:string;
    courseNumber:string;
    trainingCourseId:number;
    // }
}
